import { makeStyles } from "@material-ui/core";
import { shadow } from "../../../../assets/const";
import { color } from "../../../../assets/const/color";

export const useStyles = makeStyles(() => ({
    addStaff_main: {
        fontFamily: "inter !important",
        "& p": {
          fontFamily: "inter !important",
        },
        "& .MuiAccordionSummary-content": {
          alignItems: "center",
        },
        "& .MuiAccordionSummary-expandIconWrapper": {
          paddingRight: "10px",
        },
        "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
          paddingLeft: "10px",
          paddingRight: "0px",
        },
        "& .MuiAccordionDetails-root": {
          padding: "16px 50px 16px",
        },
        "& .MuiInputBase-root": {
          borderRadius: "50px",
          fontFamily: "inter !important",
          // minWidth: "80px !important",
        },
        "& .MuiFormControlLabel-label": {
          fontFamily: "inter !important",
        },
        
        "& .MuiCheckbox-colorPrimary.Mui-checked": {
          color: `${color.lightGreen} !important`,
        },
      },
      
      error: {
        color: "red",
        fontSize: "12px",
      },
}));
